import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import TagManager from 'react-gtm-module';

import {
  Menu,
  BackButtonContainer,
  BackButton,
  Title,
  PagesContainer,
  Pages,
  SectionItem,
  SubCategory,
  contentTypeToUrl,
  PageLabel,
  Locale,
  SmallFlag,
  Region,
  Language,
} from './MenuInner.style';

/**
 * メニュー > 「PRODUCTS」 > サブカテゴリ 及び LINE (SP 版 ヘッダー / フッター共用コンポーネント)
 */
const MenuInner = ({ close, closeMenu, category, label, locale, nestedMenuOpen, isFooterMenu }) => (
  <Menu show={nestedMenuOpen}>
    <BackButtonContainer>
      <BackButton onClick={close} color={isFooterMenu ? '#fff' : '#000'} />
      <Title className={isFooterMenu ? 'footerMenu' : null}>{label}</Title>
    </BackButtonContainer>

    <PagesContainer>
      <Pages>
        {!!(category && category.children) &&
          category.children.map(
            item =>
              item.contentType && item.contentType === 'siteOptionsProductSubcategory' ? (
                <React.Fragment key={item.label}>
                  {/* サブカテゴリ表示部分 (例) SUBLIMIC) */}
                  {!isFooterMenu && (
                    <React.Fragment>
                      {item.url ? (
                        <Link
                          to={`/${locale}${item.url}`}
                          href={`/${locale}${item.url}`}
                          onClick={() => {
                            TagManager.dataLayer({
                              dataLayer: {
                                event: 'clickheader',
                                clickurl: `/${locale}${item.url}`,
                              },
                            });
                          }}
                        >
                          <SectionItem key={item.label} onClick={closeMenu}>
                            <SubCategory>{item.label}</SubCategory>
                          </SectionItem>
                        </Link>
                      ) : (
                        <SectionItem key={item.label} onClick={closeMenu}>
                          <SubCategory>{item.label}</SubCategory>
                        </SectionItem>
                      )}
                    </React.Fragment>
                  )}

                  {isFooterMenu && (
                    <React.Fragment>
                      {item.url ? (
                        <Link
                          to={`/${locale}${item.url}`}
                          href={`/${locale}${item.url}`}
                          onClick={() => {
                            TagManager.dataLayer({
                              dataLayer: {
                                event: 'clickheader',
                                clickurl: `/${locale}${item.url}`,
                              },
                            });
                          }}
                        >
                          <SectionItem key={item.label}>
                            <SubCategory className="footerMenu">{item.label}</SubCategory>
                          </SectionItem>
                        </Link>
                      ) : (
                        <SectionItem key={item.label}>
                          <SubCategory className="footerMenu">{item.label}</SubCategory>
                        </SectionItem>
                      )}
                    </React.Fragment>
                  )}

                  {/* LINE 部分 (例) Aqua Intensive) */}
                  {item.children.map(range => (
                    <Link
                      key={range.name}
                      to={`/${locale}/${contentTypeToUrl[range.contentType]}/${range.slug}`}
                      href={`/${locale}/${contentTypeToUrl[range.contentType]}/${range.slug}`}
                      onClick={() => {
                        TagManager.dataLayer({
                          dataLayer: {
                            event: 'clickheader',
                            clickurl: `/${locale}/${contentTypeToUrl[range.contentType]}/${range.slug}`,
                          },
                        });
                      }}
                    >
                      {!isFooterMenu ? (
                        <SectionItem onClick={closeMenu}>
                          <PageLabel>{range.name}</PageLabel>
                        </SectionItem>
                      ) : (
                        <SectionItem>
                          <PageLabel className="footerMenu">{range.name}</PageLabel>
                        </SectionItem>
                      )}
                    </Link>
                  ))}
                </React.Fragment>
              ) : (
                <Link
                  key={item.name}
                  to={`/${locale}/${contentTypeToUrl[item.contentType]}/${item.slug}`}
                  href={`/${locale}/${contentTypeToUrl[item.contentType]}/${item.slug}`}
                  onClick={() => {
                    TagManager.dataLayer({
                      dataLayer: {
                        event: 'clickheader',
                        clickurl: `/${locale}/${contentTypeToUrl[item.contentType]}/${item.slug}`,
                      },
                    });
                  }}
                >
                  {!isFooterMenu ? (
                    <SectionItem onClick={closeMenu}>
                      <PageLabel>{item.name}</PageLabel>
                    </SectionItem>
                  ) : (
                    <SectionItem>
                      <PageLabel className="footerMenu">{item.name}</PageLabel>
                    </SectionItem>
                  )}
                </Link>
              )
          )}

        {!!(category && category.availableRegions) &&
          category.availableRegions.map(region => {
            const url = window.location.pathname
              .split('/')
              .slice(2)
              .join('/');

            return (
              <React.Fragment key={region.region}>
                {region.languages.map(
                  lang =>
                    locale === lang.locale ? (
                      <Locale key={lang.locale}>
                        <SmallFlag src={region.icon} />
                        <Region>{region.region}</Region>
                        <Language>{lang.label}</Language>
                      </Locale>
                    ) : (
                      <a
                        key={lang.locale}
                        to={`/${lang.locale}/${url}`}
                        href={`/${lang.locale}/${url}`}
                        onClick={() => {
                          TagManager.dataLayer({
                            dataLayer: {
                              event: 'clickheader',
                              clickurl: `/${lang.locale}/${url}`,
                            },
                          });
                        }}
                      >
                        <Locale>
                          <SmallFlag src={region.icon} />
                          <Region>{region.region}</Region>
                          <Language>{lang.label}</Language>
                        </Locale>
                      </a>
                    )
                )}
              </React.Fragment>
            );
          })}
      </Pages>
    </PagesContainer>
  </Menu>
);

MenuInner.defaultProps = {
  isFooterMenu: false,
  closeMenu: null,
};

MenuInner.propTypes = {
  category: PropTypes.shape().isRequired,
  close: PropTypes.func.isRequired,
  closeMenu: PropTypes.func,
  label: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  nestedMenuOpen: PropTypes.bool.isRequired,
  isFooterMenu: PropTypes.bool,
};

const mapState = state => ({
  locale: state.locale,
});

export default connect(mapState)(MenuInner);



// WEBPACK FOOTER //
// ./src/components/GlobalMenu/Mobile/MenuInner.js